<template>
  <div class="v3-events-grid">
    <div class="event-grid-item" v-for="event in eventArray" :key="event">
      <a :href="event.event_url">
        <img class="event-image" :alt="event.image_alt" :src="event.image_url">
        <div class="event-grid-inner-wrapper">
          <img class="filter-gold" alt="B&G chevron icon" style="width: 30px; max-width: 100%;" src="https://cloud.bartonandgray.com/library/ux/icons/chevrons/arrow-next.svg">
          <div class="v4-heading-three color-gradient-shark-reversed">{{ event.title }}<br>{{ event.date }}</div>
        </div>
        <p class="v4-body-paragraph color-storm">
          {{ event.paragraph }}
        </p>
      </a>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import EventData from './eventsData.json';
  const eventArray = EventData;

  onMounted(() => {
    console.log(eventArray);
  });
</script>

<style lang="scss">

.event-grid-inner-wrapper{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding-top: 1em;
}

</style>